import orgUsageModalUrl from './orgUsageModal.tpl.html';
import { orgUsageFeaturesEndpointMap } from '../orgUsageFeaturesEndpointMap';

angular.module('signalview.orgUsageChart').service('orgUsageModalService', [
    'sfxModal',
    'organizationService',
    'linkableModalService',
    function (sfxModal, organizationService, linkableModalService) {
        linkableModalService.register(
            'usageReports',
            openModal,
            true,
            orgUsageFeaturesEndpointMap.viewIMMUsageReportsModal
        );

        return {
            showUsageReports: () => {
                linkableModalService.open('usageReports');
            },
        };

        function openModal() {
            return sfxModal.open({
                templateUrl: orgUsageModalUrl,
                controller: 'OrgUsageModalController',
                size: 'lg',
                resolve: {
                    org: function () {
                        return organizationService.get();
                    },
                },
            });
        }
    },
]);
